// extracted by mini-css-extract-plugin
export default {"btn":"DownloadBtn_btn__568-q"};